import React from "react";
import Checkbox from "@mui/material/Checkbox";
import { formatDateReadable } from "../../../utilities/helpers";


function CarryOverPanel(props) {
  const items = props.items || [];

  if (items.length === 0) return null;

  return (
    <div className="bg-violet-50 border border-violet-200 rounded-xl p-4">
      <h3 className="text-sm font-semibold text-violet-900 mb-1">
        Carry-over from previous check-ins
      </h3>
      <p className="text-xs text-violet-700 mb-3">
        Toggle done as you discuss them. Open items stay surfaced on future check-ins.
      </p>
      <ul className="space-y-1">
        {items.map((item) => {
          const isDone = !!item.completed_at;
          return (
            <li
              key={item.uuid}
              className="flex items-center gap-2 text-sm"
            >
              <Checkbox
                checked={isDone}
                onChange={() => props.onToggle(item.uuid)}
                size="small"
                sx={{
                  padding: 0,
                  "&.Mui-checked": { color: "#6d28d9" },
                }}
              />
              <span
                className={`flex-1 ${
                  isDone ? "text-slate-400 line-through" : "text-slate-800"
                }`}
              >
                {item.text}
              </span>
              {item.due_date && (
                <span className="text-xs text-slate-500">
                  Due {formatDateReadable(item.due_date)}
                </span>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default CarryOverPanel;
